module.exports = __webpack_public_path__ + "static/media/edit.96c2cdc2.svg";